import { useParams } from 'react-router'
import HomeOpportunitiesMessageAr from './HomeOpportunitiesMessageAr'
import HomeOpportunitiesMessageEn from './HomeOpportunitiesMessageEn'
import { Link } from 'react-router-dom'

const HomeOpportunitiesSection = () => {
  const { lng } = useParams()

  return (
    <Link
      to={`/${lng}/opportunities`}
      className="bg-secondary-600 group relative flex h-[458px] overflow-hidden"
    >
      <div className="absolute left-0 right-0 top-0 z-50 h-full w-full">
        <img
          className="h-full w-full object-cover opacity-20 transition duration-300 ease-in-out group-hover:scale-150"
          src="/assets/backgrounds/opportunities-background.svg"
          alt="Mining Opportunities pattern"
        />
      </div>
      <div className="app-container relative h-full px-8">
        <div className="absolute z-50 h-full w-full">
          <div
            data-aos="fade-up"
            className="flex h-full items-center transition ease-in-out group-hover:scale-105"
          >
            {lng === 'ar' ? <HomeOpportunitiesMessageAr /> : <HomeOpportunitiesMessageEn />}
          </div>
        </div>
        <div className="from-secondary-600 via-secondary-600/80 absolute top-0 z-40 h-full w-1/2 to-transparent ltr:right-0 ltr:bg-gradient-to-r rtl:left-0 rtl:bg-gradient-to-l"></div>
      </div>
      <div className="absolute top-0 h-full w-1/2 overflow-hidden ltr:right-0 rtl:left-0">
        <img
          className="h-full w-full object-cover transition duration-300 ease-in-out group-hover:scale-150"
          src="/assets/images/opportunities-banner.webp"
          alt="Mining Opportunities"
        />
      </div>
    </Link>
  )
}

export default HomeOpportunitiesSection
